export default "__VITE_ASSET__0cde0d6e__"